import { createFileRoute } from '@tanstack/react-router';
import { ReferenceToVideoPage } from '@/components/custom/reference-to-video-page';
import { getReferenceToVideoSeoData } from '@/components/custom/reference-to-video-seo-data';
import { seo } from '@/lib/seo';
import { getImageUrl } from '@/lib/urls';

export const Route = createFileRoute('/reference-to-video')({
  head: () => {
    const data = getReferenceToVideoSeoData();
    return seo(data.path, {
      title: data.seoTitle,
      description: data.seoDescription,
      keywords: data.keywords,
      image: getImageUrl(data.ogImage),
    });
  },
  component: ReferenceToVideoRoute,
});

function ReferenceToVideoRoute() {
  return <ReferenceToVideoPage />;
}
